import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

import Paper from '@joinforma/ui/components/Paper';
import { ScreenWidth } from '@joinforma/ui/constants/breakpoints';

const Container = styled(Paper)`
  padding-top: 25px;
  height: 100%;
  max-width: 1160px;
  margin: 0 auto;

  @media (max-width: ${ScreenWidth.LAPTOP}) {
    max-width: 892px;
    margin: 0 16px;
  }

  @media (max-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    max-width: 634px;
    margin: 0 16px;
  }
`;

const StoreLayout = ({ children }: { children?: React.ReactNode }) => (
  <Container>{children ?? <Outlet />}</Container>
);

export default StoreLayout;
